import hasFeature from 'src/lib/hasFeature';

import BaseLayout from './BaseLayout';
import TauronBaseLayout from './TauronBaseLayout';

export default hasFeature('tauron') ? TauronBaseLayout : BaseLayout;
